import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-dc-document-viewer',
    templateUrl: './dc-document-viewer.component.html',
    styleUrls: ['./dc-document-viewer.component.scss'],
    standalone: false
})
export class DcDocumentViewerComponent implements OnInit {
  @Input() docFormat: string;
  @Input() docSrc: string;
  @Input() docName: string;
  constructor() {}

  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes);
  }

  downloadDocument() {
    this.writeContents(this.docSrc, this.docName);
  }

  writeContents(content, fileName) {
    let a = document.createElement('a');
    let file;
    file = this.convertBase64ToBlob(content);
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  private convertBase64ToBlob(base64Image: string) {
    // Split into two parts
    const parts = base64Image.split(';base64,');

    // Hold the content type
    const imageType = parts[0].split(':')[1];

    // Decode Base64 string
    const decodedData = window.atob(parts[1]);

    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);

    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }

    // Return BLOB image after conversion
    return new Blob([uInt8Array], { type: imageType });
  }
}
